/*
  CK Store — Size finder
  Recommends a size from height (cm) + weight (kg) and selects it in the variant picker.
  Supports kids sizes written as ages ("6 months", "2-3 years", "4", "6-7 ans", "٦ أشهر")
  and adult letter sizes (XS … 5XL, 2XL / XXL, etc.).
*/
(function () {
  if (window.customElements && window.customElements.get('size-finder')) return;

  var STORAGE_KEY = 'ck-size-finder';

  /* Average child growth (both sexes, WHO/CDC 50th percentile, rounded).
     [age in months, height cm, weight kg] */
  var GROWTH = [
    [0, 50, 3.4], [3, 61, 6.0], [6, 67, 7.8], [9, 72, 8.9], [12, 76, 9.8],
    [18, 82, 11.0], [24, 87, 12.4], [36, 96, 14.3], [48, 103, 16.3],
    [60, 110, 18.4], [72, 116, 20.6], [84, 122, 23.0], [96, 128, 25.6],
    [108, 133, 28.6], [120, 139, 32.0], [132, 144, 35.6], [144, 150, 40.0],
    [156, 157, 45.0], [168, 163, 50.0], [180, 168, 55.0], [192, 172, 60.0],
    [216, 175, 65.0]
  ];

  /* Adult unisex hoodie / set chart. index → [label, max height cm, max weight kg] */
  var ADULT = [
    ['XXS', 155, 45], ['XS', 161, 53], ['S', 168, 62], ['M', 175, 72],
    ['L', 181, 82], ['XL', 186, 93], ['2XL', 191, 105], ['3XL', 196, 117],
    ['4XL', 201, 130], ['5XL', 999, 999]
  ];

  var ADULT_ALIASES = {
    xxs: 0, '2xs': 0, xs: 1, s: 2, small: 2, m: 3, medium: 3, l: 4, large: 4,
    xl: 5, 'x-large': 5, xlarge: 5, xxl: 6, '2xl': 6, xxxl: 7, '3xl': 7,
    xxxxl: 8, '4xl': 8, xxxxxl: 9, '5xl': 9
  };

  function interp(months, col) {
    if (months <= GROWTH[0][0]) return GROWTH[0][col];
    for (var i = 1; i < GROWTH.length; i++) {
      if (months <= GROWTH[i][0]) {
        var a = GROWTH[i - 1], b = GROWTH[i];
        var t = (months - a[0]) / (b[0] - a[0]);
        return a[col] + t * (b[col] - a[col]);
      }
    }
    return GROWTH[GROWTH.length - 1][col];
  }

  function normalise(value) {
    var s = String(value).toLowerCase().trim();
    // Arabic-Indic & Persian digits → Latin
    s = s.replace(/[٠-٩]/g, function (d) { return d.charCodeAt(0) - 0x0660; })
         .replace(/[۰-۹]/g, function (d) { return d.charCodeAt(0) - 0x06F0; });
    // strip Arabic diacritics (tanween etc.) and tatweel: "12 شهرًا" → "12 شهرا"
    s = s.replace(/[\u064B-\u065F\u0670\u0640]/g, '');
    s = s.replace(/أشهر|اشهر|شهور|شهرا|شهر/g, ' months')
         .replace(/سنوات|سنين|سنتين|سنتان|سنة|سنه|أعوام|اعوام|عاما|عام/g, ' years')
         .replace(/\b(mois|meses|mes|monate|monat|mesi)\b/g, ' months')
         .replace(/\b(ans|an|años|año|jahre|jahr|anni|anno)\b/g, ' years')
         .replace(/\s+/g, ' ');
    return s.trim();
  }

  function parseSize(raw) {
    var s = normalise(raw);
    var compact = s.replace(/[\s.]/g, '');
    if (ADULT_ALIASES.hasOwnProperty(compact)) return { type: 'adult', idx: ADULT_ALIASES[compact] };

    var unitRe = '(months?|mo|m|years?|yrs?|y|t)?';
    var range = s.match(new RegExp('^(\\d+(?:\\.\\d+)?)\\s*(?:-|–|—|to|/|à|a)\\s*(\\d+(?:\\.\\d+)?)\\s*' + unitRe));
    var single = s.match(new RegExp('^(\\d+(?:\\.\\d+)?)\\s*' + unitRe + '\\s*$'));
    var a, b, unit;
    if (range) { a = parseFloat(range[1]); b = parseFloat(range[2]); unit = range[3]; }
    else if (single) { a = b = parseFloat(single[1]); unit = single[2]; }
    else return null;

    var isMonths = unit && /^mo|^m$|^months?$/.test(unit);
    var isYears = unit && /^y|^t$/.test(unit);
    if (!isMonths && !isYears) {
      if (b <= 16) isYears = true;          // "2", "4", "6-7" → years
      else return null;                      // e.g. EU adult numbers — not handled
    }
    var f = isMonths ? 1 : 12;
    return { type: 'kid', minM: a * f, maxM: b * f };
  }

  function buildKids(list) {
    var kids = list.filter(function (x) { return x.parsed && x.parsed.type === 'kid'; })
      .sort(function (x, y) { return x.parsed.minM - y.parsed.minM; });
    kids.forEach(function (k, i) {
      var next = kids[i + 1];
      var lo = k.parsed.minM;
      var hi = next ? Math.max(k.parsed.maxM, next.parsed.minM) : k.parsed.maxM + (k.parsed.maxM >= 24 ? 12 : 6);
      if (hi <= lo) hi = lo + (lo >= 24 ? 12 : 3);
      k.hMax = interp(hi, 1);
      k.wMax = interp(hi, 2);
    });
    return kids;
  }

  function firstFit(items, value, key) {
    for (var i = 0; i < items.length; i++) if (value < items[i][key]) return i;
    return items.length; // overflow
  }

  function recommend(values, height, weight, fit) {
    var list = values.map(function (v) { return { value: v, parsed: parseSize(v) }; });
    var kids = buildKids(list);
    var adults = list.filter(function (x) { return x.parsed && x.parsed.type === 'adult'; })
      .sort(function (x, y) { return x.parsed.idx - y.parsed.idx; });

    var result = null;
    var between = false;
    var edge = null;

    if (kids.length) {
      var ease = 2; // a little room to move & grow
      var iH = firstFit(kids, height + ease, 'hMax');
      var iW = firstFit(kids, weight, 'wMax');
      between = iH !== iW;
      var iK = Math.max(iH, Math.min(iW, iH + 1));
      if (fit === 'relaxed') iK += 1;
      if (iK < kids.length) {
        result = kids[iK];
      } else if (!adults.length) {
        result = kids[kids.length - 1];
        edge = 'largest';
      }
    }

    if (!result && adults.length) {
      var aH = firstFit(ADULT.map(function (r) { return { h: r[1] }; }), height, 'h');
      var aW = firstFit(ADULT.map(function (r) { return { w: r[2] }; }), weight, 'w');
      between = aH !== aW;
      var target = Math.max(aW, aH - 1);
      if (fit === 'relaxed') target += 1;
      // nearest available size at or above target
      var pick = null;
      for (var j = 0; j < adults.length; j++) {
        if (adults[j].parsed.idx >= target) { pick = adults[j]; break; }
      }
      if (!pick) { pick = adults[adults.length - 1]; edge = 'largest'; }
      else if (pick === adults[0] && target < adults[0].parsed.idx && !kids.length) edge = 'smallest';
      result = pick;
    }

    if (!result) return null;
    return { value: result.value, between: between, edge: edge };
  }

  function readJSON(el, sel) {
    var node = el.querySelector(sel);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  class SizeFinder extends HTMLElement {}

  SizeFinder.prototype.connectedCallback = function () {
    if (this._ready) return;
    this._ready = true;
    var self = this;
    this.values = readJSON(this, '[data-size-values]') || [];
    this.strings = readJSON(this, '[data-size-strings]') || {};
    this.optionName = this.dataset.optionName;
    this.optionPosition = this.dataset.optionPosition;

    this.toggle = this.querySelector('[data-size-finder-toggle]');
    this.panel = this.querySelector('[data-size-finder-panel]');
    this.heightInput = this.querySelector('[data-size-finder-height]');
    this.weightInput = this.querySelector('[data-size-finder-weight]');
    this.errorEl = this.querySelector('[data-size-finder-error]');
    this.resultEl = this.querySelector('[data-size-finder-result]');
    this.resultSize = this.querySelector('[data-size-finder-result-size]');
    this.resultMeta = this.querySelector('[data-size-finder-result-meta]');
    this.resultNote = this.querySelector('[data-size-finder-result-note]');
    this.applyBtn = this.querySelector('[data-size-finder-apply]');
    this.applyLabel = this.applyBtn.textContent.trim();

    this.toggle.addEventListener('click', function () {
      var open = self.toggle.getAttribute('aria-expanded') === 'true';
      self.toggle.setAttribute('aria-expanded', String(!open));
      self.panel.hidden = open;
      if (!open) setTimeout(function () { self.heightInput.focus({ preventScroll: true }); }, 50);
    });
    this.querySelector('[data-size-finder-submit]').addEventListener('click', function () { self.calculate(); });
    [this.heightInput, this.weightInput].forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); self.calculate(); }
      });
    });
    this.applyBtn.addEventListener('click', function () { self.applySize(self.current, true); });

    // Restore last entered measurements for this shopper (convenience only)
    try {
      var saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      if (saved) {
        if (saved.h) this.heightInput.value = saved.h;
        if (saved.w) this.weightInput.value = saved.w;
      }
    } catch (e) { /* storage unavailable */ }
  };

  SizeFinder.prototype.fit = function () {
    var checked = this.querySelector('[data-size-finder-fit]:checked');
    return checked ? checked.value : (this.dataset.defaultFit || 'regular');
  };

  SizeFinder.prototype.showError = function (msg) {
    this.errorEl.textContent = msg;
    this.errorEl.hidden = !msg;
  };

  SizeFinder.prototype.calculate = function () {
    var h = parseFloat(String(this.heightInput.value).replace(',', '.'));
    var w = parseFloat(String(this.weightInput.value).replace(',', '.'));
    if (!(h >= 40 && h <= 230)) { this.showError(this.strings.height_required || 'Please enter a height between 40 and 230 cm.'); this.heightInput.focus(); return; }
    if (!(w >= 2 && w <= 250)) { this.showError(this.strings.weight_required || 'Please enter a weight between 2 and 250 kg.'); this.weightInput.focus(); return; }
    this.showError('');

    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ h: h, w: w })); } catch (e) { /* ignore */ }

    var fit = this.fit();
    var rec = recommend(this.values, h, w, fit);
    if (!rec) {
      this.resultEl.hidden = false;
      this.resultSize.textContent = '—';
      this.resultMeta.textContent = this.strings.no_match || '';
      this.resultNote.hidden = true;
      this.applyBtn.hidden = true;
      return;
    }

    this.current = rec.value;
    this.applyBtn.textContent = this.applyLabel;
    this.applyBtn.classList.remove('is-applied');
    this.resultSize.textContent = rec.value;
    var fitLabel = fit === 'relaxed' ? (this.strings.fit_relaxed || 'Relaxed') : (this.strings.fit_regular || 'Regular');
    this.resultMeta.textContent = (this.strings.based_on || '{{ height }} cm · {{ weight }} kg · {{ fit }}')
      .replace('{{ height }}', h).replace('{{ weight }}', w).replace('{{ fit }}', fitLabel);

    var notes = [];
    if (rec.edge === 'largest') notes.push(this.strings.largest_note);
    if (rec.edge === 'smallest') notes.push(this.strings.smallest_note);
    if (rec.between && !rec.edge) notes.push(this.strings.between_sizes);
    var chip = this.findChip(rec.value);
    if (chip && chip.classList.contains('disabled')) notes.push(this.strings.sold_out_note);
    notes = notes.filter(Boolean);
    this.resultNote.textContent = notes.join(' ');
    this.resultNote.hidden = notes.length === 0;

    this.applyBtn.hidden = false;
    this.resultEl.hidden = false;
    this.markRecommended(rec.value);
    this.saveToOrder(h, w, fitLabel, rec.value);
    document.dispatchEvent(new CustomEvent('ck:size-recommended', { detail: { value: rec.value, optionName: this.optionName } }));
    if (this.dataset.autoSelect !== 'false') this.applySize(rec.value, false);
  };

  // Attach the shopper's measurements to the cart line as line-item properties,
  // so they appear on the order in Shopify admin (Orders › order › line item).
  SizeFinder.prototype.saveToOrder = function (h, w, fitLabel, size) {
    var st = this.strings;
    var props = {};
    props[st.prop_height || 'Height'] = h + ' cm';
    props[st.prop_weight || 'Weight'] = w + ' kg';
    props[st.prop_fit || 'Size finder'] = (st.prop_recommended || 'Recommended') + ' ' + size + ' · ' + fitLabel;
    window.CKSizeFinderData = { properties: props, size: size, optionPosition: this.optionPosition };

    var scope = this.scope();
    var forms = scope.querySelectorAll('form[action*="/cart/add"]');
    if (!forms.length && scope.tagName === 'FORM') forms = [scope];
    Array.prototype.forEach.call(forms, function (form) {
      form.querySelectorAll('input[data-ck-sf-prop]').forEach(function (el) { el.remove(); });
      Object.keys(props).forEach(function (key) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + key + ']';
        input.value = props[key];
        input.setAttribute('data-ck-sf-prop', '');
        form.appendChild(input);
      });
    });
  };

  SizeFinder.prototype.scope = function () {
    return this.closest('.shopify-section, .quick-product, [data-product-container], form') || document;
  };

  SizeFinder.prototype.findChip = function (value) {
    var scope = this.scope();
    var chips = scope.querySelectorAll('[data-product-option="option' + this.optionPosition + '"] [data-option-value]');
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].getAttribute('data-option-value') === value) return chips[i];
    }
    return null;
  };

  SizeFinder.prototype.markRecommended = function (value) {
    var scope = this.scope();
    scope.querySelectorAll('.is-size-recommended').forEach(function (el) { el.classList.remove('is-size-recommended'); });
    var chip = this.findChip(value);
    if (chip) chip.classList.add('is-size-recommended');
  };

  SizeFinder.prototype.applySize = function (value, scrollIntoView) {
    if (!value) return;
    var chip = this.findChip(value);
    if (chip) {
      if (!chip.classList.contains('selected')) chip.click();
    } else {
      // Fallback: drive the native select the theme listens to
      var scope = this.scope();
      var selects = scope.querySelectorAll('select[name^="options["]');
      for (var i = 0; i < selects.length; i++) {
        if (selects[i].name === 'options[' + this.optionName + ']') {
          selects[i].value = value;
          selects[i].dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    }
    this.applyBtn.textContent = this.strings.selected || 'Selected ✓';
    this.applyBtn.classList.add('is-applied');
    if (scrollIntoView && chip) chip.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  // Expose for testing
  SizeFinder.recommend = recommend;
  SizeFinder.parseSize = parseSize;
  window.CKSizeFinder = SizeFinder;

  window.customElements.define('size-finder', SizeFinder);
})();
